// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Adrian Kluska <adrian.kluska@movecloser.pl>
 */
let Screen = class Screen extends Vue {
    constructor() {
        super(...arguments);
        this.isOffScreen = false;
        this.isOpen = false;
    }
    open() {
        this.isOpen = true;
        if (typeof window === 'undefined' ||
            (this.$el.getBoundingClientRect().height > window.innerHeight)) {
            this.isOffScreen = true;
        }
    }
};
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], Screen.prototype, "delayed", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], Screen.prototype, "hideOnLoading", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], Screen.prototype, "loading", void 0);
Screen = __decorate([
    Component({
        name: 'Screen',
        mounted() {
            this.$nextTick(() => {
                if (this.delayed) {
                    setTimeout(this.open, 250);
                }
                else {
                    this.open();
                }
            });
        },
        beforeDestroy() {
            this.isOpen = false;
        },
        template: `
    <div class="screen" :class="{ '--off-screen': isOffScreen, '--open': isOpen || !delayed, '--hidden': hideOnLoading }">
      <slot v-if="!(hideOnLoading && loading)" />
      <div v-if="loading" class="screen__overlay">
        <div class="screen__overlay__spinner" />
      </div>
    </div>
  `
    })
], Screen);
export { Screen };
